import React, { useEffect } from "react";
import NoRecordFound from "components/NoRecordFound/NoRecordFound";
import {
  Table
} from "reactstrap";
import moment from "moment";
import { getSortCls, reportloader } from "services/util";
import { btnCss, iconCss, ReportStatus } from '../../appConfig';
import FullPageLoader from "components/FullPageLoader/fullpageloader";


const sortIS = {
  sortCreatedAt: 0,
  sortMerchantName: 0,
  sortBank_MMOCode: 0,
  sortPayingBankCode: 0,
  sortReceivingBank: 0,
  sortAmount: 0,
  sortFeesAmount: 0,
  sortReferenceId: 0,
  sortStatus: 0,
  sortUpdatedAt: 0
};

const reportloaderContainer = {
  position: 'absolute',
  top: '280px',
  left: 0,
  width: '100%',
  heigth: '100%',
  backgroundColor: '#F8F8F8AD',
  // display: 'none'
};

const STATUS = ReportStatus;


const SettlementReportTable = (props) => {

  const [filteredList, setFilteredList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = React.useState(sortIS);

  useEffect(()=> {
    setFilteredList(props.datalist)
  }, [props.datalist]);

  useEffect(()=> {
    setCurrentPage(props.currentPage);
  }, [props.currentPage]);

  useEffect(()=> {
    setPageSize(props.pageSize);
  }, [props.pageSize]);

  useEffect(()=> {
    props.setParentSort(sort);
  }, [sort]);

  const getAmt = (amt) => {
    return amt.toLocaleString();
  }

  const sortHandle = (fieldValue, fieldName) => {
    let newValue = 0;
    if (fieldValue == "0") {
      newValue = '1';
    } else if (fieldValue == "1") {
      newValue = '2';
    } else if (fieldValue == "2") {
      newValue = '1';
    }
    setSort({ ...sortIS, [fieldName]: newValue });
  }

  const statusFormat = (val) => {
    let ob = STATUS.find((s) => s.key === val);
    return ob && ob.value ? ob.value : val 
  };

  return (
    <>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col"
              onClick={() => sortHandle(sort.sortCreatedAt, 'sortCreatedAt')}>
              Instruction Date/Time
              <button style={btnCss} >
                <i className={getSortCls(sort.sortCreatedAt)}
                  onClick={() => sortHandle(sort.sortCreatedAt, 'sortCreatedAt')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortMerchantName, 'sortMerchantName')}>
              Merchant Name
              <button style={btnCss} >
                <i className={getSortCls(sort.sortMerchantName)}
                  onClick={() => sortHandle(sort.sortMerchantName, 'sortMerchantName')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortPayingBankCode, 'sortPayingBankCode')}>
              Paying Bank Code
              <button style={btnCss} >
                <i className={getSortCls(sort.sortPayingBankCode)}
                  onClick={() => sortHandle(sort.sortPayingBankCode, 'sortPayingBankCode')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortReceivingBank, 'sortReceivingBank')}>
              Receving Bank Code
              <button style={btnCss} >
                <i className={getSortCls(sort.sortReceivingBank)}
                  onClick={() => sortHandle(sort.sortReceivingBank, 'sortReceivingBank')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortAmount, 'sortAmount')}>
              Transaction Amount
              <button style={btnCss} >
                <i className={getSortCls(sort.sortAmount)}
                  onClick={() => sortHandle(sort.sortAmount, 'sortAmount')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortFeesAmount, 'sortFeesAmount')}>
              Transaction Fees
              <button style={btnCss} >
                <i className={getSortCls(sort.sortFeesAmount)}
                  onClick={() => sortHandle(sort.sortFeesAmount, 'sortFeesAmount')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortReferenceId, 'sortReferenceId')}>
              Transaction Ref
              <button style={btnCss} >
                <i className={getSortCls(sort.sortReferenceId)}
                  onClick={() => sortHandle(sort.sortReferenceId, 'sortReferenceId')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortStatus, 'sortStatus')}>
              Status
              <button style={btnCss} >
                <i className={getSortCls(sort.sortStatus)}
                  onClick={() => sortHandle(sort.sortStatus, 'sortStatus')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortUpdatedAt, 'sortUpdatedAt')}>
              Clearing Date/Time
              <button style={btnCss} >
                <i className={getSortCls(sort.sortUpdatedAt)}
                  onClick={() => sortHandle(sort.sortUpdatedAt, 'sortUpdatedAt')}
                />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
        {filteredList.length > 0 && filteredList.map((mmo, i)  => {
          return (
            <tr>
              <td scope="row">
                {moment(mmo.createdat).format('lll')}
              </td>
              <td>{mmo.merchantName}</td>
              <td>{mmo.payingBankCode}</td>
              <td>{mmo.receivingBank}</td>
              <td>{getAmt(mmo.amount)}</td>
              <td>{getAmt(mmo.feesAmount)}</td>
              <td>{mmo.referenceId}</td>
              <td>{statusFormat(mmo.status)}</td>
              <td>{mmo.updatedAt ? moment(mmo.updatedAt).format('lll') : '--'}</td>
            </tr>

          )
        }
        )}
        </tbody>
        {props.loading && 
          <FullPageLoader label={"Fetching..."} 
            loaderContainer={reportloaderContainer}
            loader={reportloader}
          />
        }
        {!props.loading && !filteredList.length && 
          <NoRecordFound 
            loaderContainer={reportloaderContainer}
            loader={reportloader}
          />
        }
      </Table>       
    </>
  )
}

export default SettlementReportTable;